import { Style } from '@/components/style';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { ReactComponent as Warn } from '@/assets/img/warn.svg';
import { ReactComponent as ArrowDown } from '@/assets/img/arrow_down_gray3.svg';
import { ReactComponent as ArrowDownAlert } from '@/assets/img/arrow_down_alert.svg';
import { ReactComponent as TimeDateIcon } from '@/assets/img/time-date-icon.svg';
import { ReactComponent as TimeDateGray3Icon } from '@/assets/img/time-date-icon-gray3.svg';

import { RootStateOrAny, useSelector } from 'react-redux';
import OrderServeType from '@/constants/OrderServeType';

const { alertColor, blackColor, primaryColor, gray3Color } =
  new Style().getUiConfig();

function WelcomeTakeoutSelector({
  webStoreVo,
  selectedServeType,
  selectedTakeOutServeType,
  setSelectedTakeOutServeType,
}) {
  const [isTakeOutSelectorValid, setIsTakeOutSelectorValid] =
    useState<boolean>(true);
  const isSelectedServeTypeValid = useSelector(
    (state: RootStateOrAny) =>
      state.customizeWelcomeReducer.isSelectedServeTypeValid
  );

  useEffect(() => {
    setIsTakeOutSelectorValid(isSelectedServeTypeValid);
  }, [isSelectedServeTypeValid]);

  useEffect(() => {
    if (selectedTakeOutServeType !== OrderServeType.DEFAULT)
      setIsTakeOutSelectorValid(true);
  }, [selectedTakeOutServeType]);
  return (
    <div>
      {selectedServeType === OrderServeType.TAKE_OUT && (
        <div className="position-relative">
          <button
            className="btn btn-lg takeout"
            style={
              selectedTakeOutServeType === 'DEFAULT'
                ? {
                    border: `1px solid ${
                      isTakeOutSelectorValid ? gray3Color : alertColor
                    }`,
                    color: `${gray3Color}`,
                  }
                : {
                    border: `1px solid ${
                      isTakeOutSelectorValid ? gray3Color : alertColor
                    }`,
                    color: `${blackColor}`,
                  }
            }
            type="button"
            data-testid="takeoutDropDownMenu"
            id="takeoutDropDownMenu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center justify-content-start">
                {selectedTakeOutServeType === 'DEFAULT' ? (
                  <TimeDateGray3Icon className="me-2" />
                ) : (
                  <TimeDateIcon className="me-2" />
                )}
                <FormattedMessage
                  id={`welcome.availableTakeOutServeTypes.${selectedTakeOutServeType}`}
                />
              </div>

              {isTakeOutSelectorValid ? <ArrowDown /> : <ArrowDownAlert />}
            </div>
          </button>

          {isTakeOutSelectorValid && <div style={{ marginBottom: '10px' }} />}
          {!isTakeOutSelectorValid && (
            <div
              className="d-flex align-items-center"
              style={{
                color: alertColor,
                fontSize: '12px',
                margin: '5px 0px 10px 0px',
              }}
            >
              <Warn style={{ marginRight: '5px' }} />
              <FormattedMessage id="welcome.availableTakeOutServeTypes.DEFAULT.warn" />
            </div>
          )}
          <ul
            style={{
              width: '100%',
              border: `1px solid ${gray3Color}`,
            }}
            className="dropdown-menu takeout-list position-absolute"
            aria-labelledby="takeoutDropDownMenu"
          >
            {webStoreVo.availableTakeOutServeTypes.map(
              (serveType: OrderServeType, i: number) => (
                <li key={i} className="div-hover">
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ fontSize: '16px', height: '45px' }}
                    onClick={() => {
                      setSelectedTakeOutServeType(serveType);
                    }}
                  >
                    <FormattedMessage
                      id={`welcome.availableTakeOutServeTypes.${serveType}`}
                    />
                  </div>
                </li>
              )
            )}
          </ul>
        </div>
      )}
    </div>
  );
}

WelcomeTakeoutSelector.defaultProps = {};

WelcomeTakeoutSelector.propTypes = {
  webStoreVo: PropTypes.shape({
    availableServeTypes: PropTypes.arrayOf(PropTypes.string),
    availableTakeOutServeTypes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  selectedServeType: PropTypes.string.isRequired,
  selectedTakeOutServeType: PropTypes.string.isRequired,
  setSelectedTakeOutServeType: PropTypes.func.isRequired,
};

export default WelcomeTakeoutSelector;
